import type { ChecklistRespostaValor } from '@portal-leo/shared';

export type SectionStatus = 'CONCLUIDA' | 'ATRASADO' | 'VENCENDO' | 'NO_PRAZO' | 'SEM_PRAZO';

export const sectionStatusConfig: Record<SectionStatus, { label: string; bg: string; text: string }> = {
  CONCLUIDA: { label: 'Concluída', bg: 'bg-green-100', text: 'text-green-800' },
  ATRASADO: { label: 'Atrasado', bg: 'bg-red-100', text: 'text-red-800' },
  VENCENDO: { label: 'Vencendo', bg: 'bg-yellow-100', text: 'text-yellow-800' },
  NO_PRAZO: { label: 'No prazo', bg: 'bg-blue-100', text: 'text-blue-800' },
  SEM_PRAZO: { label: 'Sem prazo', bg: 'bg-gray-100', text: 'text-gray-600' },
};

interface ItemWithPrazo {
  id: string;
  tipo: string;
  dataPrazo?: string | null;
}

function isItemFilled(_item: ItemWithPrazo, valor: ChecklistRespostaValor | undefined): boolean {
  if (!valor) return false;
  const v = valor.valor;
  if (v === null || v === undefined) return false;
  if (typeof v === 'string' && v === '') return false;
  if (Array.isArray(v) && v.length === 0) return false;
  return true;
}

/** Collect all current item IDs from checklist sections */
export function collectCurrentItemIds(secoes: { itens: { id: string }[] }[]): Set<string> {
  const ids = new Set<string>();
  for (const secao of secoes) {
    for (const item of secao.itens) {
      ids.add(item.id);
    }
  }
  return ids;
}

/** Filter valores to only contain entries for IDs that exist in the current structure */
export function filterValoresToCurrentItems(
  valores: Record<string, ChecklistRespostaValor>,
  currentItemIds: Set<string>,
): Record<string, ChecklistRespostaValor> {
  const filtered: Record<string, ChecklistRespostaValor> = {};
  for (const id of currentItemIds) {
    if (id in valores) {
      filtered[id] = valores[id]!;
    }
  }
  return filtered;
}

export function computeSectionStatus(
  items: ItemWithPrazo[],
  valores: Record<string, ChecklistRespostaValor>,
): SectionStatus {
  if (items.length === 0) return 'SEM_PRAZO';

  const allFilled = items.every((item) => isItemFilled(item, valores[item.id]));
  if (allFilled) return 'CONCLUIDA';

  const now = new Date();
  now.setHours(0, 0, 0, 0);

  const threeDaysFromNow = new Date(now);
  threeDaysFromNow.setDate(threeDaysFromNow.getDate() + 3);

  let hasAtrasado = false;
  let hasVencendo = false;
  let hasComPrazo = false;

  for (const item of items) {
    if (isItemFilled(item, valores[item.id])) continue;
    if (!item.dataPrazo) continue;

    hasComPrazo = true;
    const prazo = new Date(item.dataPrazo + 'T00:00:00');

    if (prazo < now) {
      hasAtrasado = true;
    } else if (prazo <= threeDaysFromNow) {
      hasVencendo = true;
    }
  }

  if (hasAtrasado) return 'ATRASADO';
  if (hasVencendo) return 'VENCENDO';
  if (hasComPrazo) return 'NO_PRAZO';
  return 'SEM_PRAZO';
}
